import { Badge } from '@chakra-ui/react';

import { employerPlacementStatusMetadata, journeyStatusMetadata } from './constants';

// Re-exported so consumers can reach the metadata via the externally-resolvable
// `.tsx` entrypoint (the package only maps `./components/*` to `.tsx` files).
export { employerPlacementStatusMetadata, journeyStatusMetadata } from './constants';

function StatusBadge({
  label,
  color,
  variant,
}: {
  label: string;
  color: string;
  variant: string;
}): React.ReactElement {
  return (
    <Badge
      fontSize="xs"
      fontWeight="bold"
      borderRadius="full"
      colorScheme={color}
      variant={variant}
      textTransform="none"
      whiteSpace="nowrap"
    >
      {label}
    </Badge>
  );
}

export function JourneyStatusBadge({
  status,
  onHold = false,
}: {
  status: keyof typeof journeyStatusMetadata;
  onHold?: boolean;
}): React.ReactElement {
  const meta = onHold
    ? { label: 'On hold', color: 'gray', variant: 'outline' }
    : journeyStatusMetadata[status];

  return <StatusBadge {...meta} />;
}

export function EmployerPlacementStatusBadge({
  status,
  onHold = false,
}: {
  status: keyof typeof employerPlacementStatusMetadata;
  onHold?: boolean;
}): React.ReactElement {
  const meta = onHold
    ? { label: 'On hold', color: 'gray', variant: 'outline' }
    : employerPlacementStatusMetadata[status];

  return <StatusBadge {...meta} />;
}
